import { render } from "./AddNewDepartment.vue?vue&type=template&id=a3452490"
import script from "./AddNewDepartment.vue?vue&type=script&lang=js"
export * from "./AddNewDepartment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__